import { useEffect, useState } from "react";
import { Title } from "./base/Title";
import {
  BaseQuestion,
  YesOrNoQuestion,
  InputNumberQuestion,
  InputQuestion,
  ScoredAnswerQuestion,
  ScoredAnswerQuestion1,
  ScoredAnswerQuestion2,
  CheckboxAnswerQuestion,
  RadioGroupAnswerQuestion,
  TableQuestion, ScenarioQuestion, ScenarioQuestion1
} from "./base/BaseQuestion";
import { generateUUID } from "../utils/generateUUID";


import { Form } from "antd";
import { StepButton } from "./step-button";
export const Section4 = ({
  title,
  currentVehicle,
  handleSubmit,
  handleFail,
  currentStep,
  flowStepsLenght,
}) => {
  const majorIndex = 4;
  // const title = "khảo sát sở thích tuyên bố";
  const [before, setBefore] = useState([]);
  const [after, setAfter] = useState([]);
  const [nextStep, setNextStep] = useState();

  const randomScenario = () => {
    return Math.floor(Math.random() * 35);
  };

  useEffect(() => {
    while (before.length < 5) {
      const randomIndex = randomScenario();
      if (before.indexOf(randomIndex) === -1) {
        before.push(randomIndex);
      }
    }
    while (after.length < 5) {
      const randomIndex = randomScenario();
      if (after.indexOf(randomIndex) === -1) {
        after.push(randomIndex);
      }
    }
  }, []);
  const renderTable = () => {
    return (
      <>
        <table className="table-fixed border-collapse w-full text-center">
          <thead>
            <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
              <th className="border-[1px] border-dashed border-gray-500">
                <p className="font-normal">
                  Phương thức hiện tại Anh/Chị đang sử dụng
                </p>
              </th>
              <th className="border-[1px] border-dashed border-gray-500">
                <p className="font-normal">
                  Phương thức 1: Dịch vụ gọi xe tự hành,{" "}
                  <span className="font-semibold">chia sẻ</span> chuyến đi với
                  nhiều người khác
                </p>
              </th>
              <th className="border-[1px] border-dashed border-gray-500">
                <p className="font-normal">
                  Phương thức 2: Dịch vụ gọi xe tự hành, chỉ một mình,{" "}
                  <span className="font-semibold">không chia sẻ</span> chuyến đi
                  với người khác
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">
              <td className="border-x-[1px] border-dashed border-gray-500">
                <p className="font-semibold">{currentVehicle}</p>
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <img
                  src={require("../assets/images/anh.png")}
                  width="80%"
                  height={"80%"}
                  className="rounded-lg mx-auto my-1"
                ></img>
              </td>
              <td className="border-x-[1px] border-dashed border-gray-500">
                <img
                  src={require("../assets/images/notSharedService.jpg")}
                  width="80%"
                  height={"80%"}
                  className="rounded-lg mx-auto my-1"
                ></img>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    );
  };
  const renderDescription = () => {
    return (
      <div>
        <div>
          <p>
            <b>Mobility-as-a-Service - MaaS (Nền tảng Di chuyển như một Dịch vụ)</b> là một phương thức tích hợp các <b>phương tiện giao thông công cộng</b> (metro, xe bus, xe đạp chia sẻ...) và các <b>dịch vụ di chuyển</b> (dịch vụ gọi xe máy/ô-tô) vào một nền tảng duy nhất. Nền tảng này cho phép người dùng lập kế hoạch hành trình, mua vé và thanh toán, giúp việc di chuyển trở nên thuận tiện, hiệu quả, tiết kiệm thời gian và thân thiện với môi trường hơn.
          </p>

          {/* {renderTable()} */}
        </div>
        <div className="my-4">
          <p>
            Đặc biệt, <b>MaaS</b> có thể cung cấp các <b>gói di chuyển</b> thuận tiện, với nhiều tiện ích tương ứng với các cấp độ sử dụng, mức giá và các dịch vụ đi kèm khác nhau. Người dùng có thể linh hoạt lựa chọn và thanh toán cho 1 lần duy nhất định kỳ.
          </p>
          <img
            src={require("../assets/images/5.png")}
            width="100%"
            height={"100%"}
            className="rounded-lg"
          ></img>
          <center><i>Người dùng có thể sử dụng nhiều loại phương tiện giao thông chia sẻ thông qua
            chỉ <b>1 nền tảng duy nhất</b>
          </i></center>
        </div>
        <p>
          Dưới đây là các gói dịch vụ <b>MaaS</b> tiềm năng được đề xuất để triển khai tại thành phố Hà Nội như một giải pháp đi lại mới dành cho người dân. Tất cả các <b>gói di chuyển</b> đều đã bao gồm ưu đãi <b>sử dụng không giới hạn metro</b>. Việc kết nối các loại hình di chuyển khác nhằm tăng khả năng kết nối với các tuyến metro.
          Mỗi gói dịch vụ cung cấp các tiện ích và mức độ sử dụng khác nhau.
        </p>
        <p>
          Anh/ChịVui lòng xem xét kỹ và chọn các <b>gói di chuyển</b> MaaS phù hợp nhất với sở thích và nhu cầu di chuyển của Anh/Chị.
        </p>

        <b>(*) Lưu ý:</b>
        <ul class="custom-list">
          <li><i>Các gói này cung cấp khả năng sử dụng metro và buýt liên tuyến.</i></li>
          <li><i>Mục <b>"Phát thải khí nhà kính trong quá trình di chuyển" trong bảng dưới đây</b>, nếu là “Không", các phương tiện gọi xe máy/ô-tô trong gói sẽ đều sử dụng điện. Nếu là “Có”, các phương tiện sử dụng xăng/dầu.</i></li>
          <li><i>Nếu không có nhu cầu sử dụng tất cả các tiện ích trong các gói được đề xuất, hoặc chỉ sử dụng khi cần thiết, Anh/Chị vui lòng chọn phương án <b>“Đi bao nhiêu, trả bấy nhiêu”</b> (viết tắt là <b>"PAYG"</b>).</i></li>
        </ul>


      </div>
    );
  };

  return (
    <div className="text-left" style={{ textAlign: "justify" }}>
      <Title index={majorIndex} content={title} />

      {renderDescription()}
      <Form
        onFinish={(value) => handleSubmit(value, nextStep)}
        onFinishFailed={handleFail}
      >
        {/* kịch bản */}
        {before.map((scenceIndex) => (
          <ScenarioQuestion1
            key={generateUUID()}
            currentVehicle={currentVehicle}
            scenceIndex={scenceIndex}
            isBefore={true}
          />
        ))}













        <StepButton
          onStepChange={setNextStep}
          currentStep={currentStep}
          flowStepsLenght={flowStepsLenght}
        />
      </Form>
      <br />
      <br />
      <br />
    </div>
  );
};
